/**
 * E-signature integration fields returned to authenticated settings clients
 */
export class TenantSettingsPublicESignaturesDto {
  isEnabled?: boolean | null;
  senderSignerEmail?: string | null;
  senderSignerName?: string | null;
  isSenderSignerEmailConfigured?: boolean | null;
}
